import { render, staticRenderFns } from "./RobotConfig.vue?vue&type=template&id=f2ebf662"
import script from "./RobotConfig.vue?vue&type=script&lang=js"
export * from "./RobotConfig.vue?vue&type=script&lang=js"
import style0 from "./RobotConfig.vue?vue&type=style&index=0&id=f2ebf662&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports